module.exports = __webpack_public_path__ + "img/status-support.ae870765.png";